import { FC } from 'react'

import { IconAgent } from '@sequencehq/core-components'

import { NodeIconTemplate } from 'Automations/nodeDefinitions/components'
import { IconProps } from '../../types'

export const SwitchIcon: FC<IconProps> = ({ boxSize, theme = 'indigo' }) => {
  return (
    <NodeIconTemplate icon={<IconAgent />} theme={theme} boxSize={boxSize} />
  )
}
